import { RemoveRedEyeOutlined, VisibilityOff } from "@mui/icons-material";
import { IconButton, TextField } from "@mui/material";
import React, { useState } from "react";

export interface PasswordboxProps {
    password: string;
    onEnter?: () => void;
    disabled?: boolean;
    // open: boolean;
    // options: string[];
    onPasswordChange: (event: any) => void;
}

export default function Passwordbox(props: PasswordboxProps) {

    const { password, onPasswordChange, onEnter, disabled } = props;
    const handleKeyPress = (e: any) => {
        // console.log(e);
        if (e.key === 'Enter') {
            if (onEnter)
                onEnter();
        }
    }
    const onPassChange = (event: any) => {
        // console.log(event.currentTarget.value);
        onPasswordChange(event!.currentTarget!.value);
    };

    // let [passwordState, setPasswordState] = useState("");
    let [passwordMode, setPasswordMode] = useState("password");
    return (
        <div>
            <TextField
                className="text-field"
                type={passwordMode}
                variant="outlined"
                value={props.password}
                onChange={onPassChange}
                id="outlined-password-input"
                label='Zadejte heslo'
                disabled={disabled}
                onKeyDown={handleKeyPress}
                sx={{ width: '100%', '& .MuiInputBase-root': { paddingLeft: '8px', height: '58px' } }}
                InputProps={{
                    endAdornment:
                        <IconButton onClick={() => {
                            if (passwordMode === 'password')
                                setPasswordMode("text");
                            else setPasswordMode("password");
                        }}> {
                                passwordMode === 'password' ?
                                    <RemoveRedEyeOutlined /> : <VisibilityOff />
                            }</IconButton>
                }}

            />
        </div>
    );
}